// Maps ecm data to a list of routes

export default {
      'OTIC Configurations': ['general-configs', 'folders', 'utilities-monitoring', 'dashboard-notification', 'advanced-config'],
      'ECM Repository Configurations': ['ecm-repo-general', 'ecm-repo-connections', 'ecm-repo-partitions', 'ecm-repo-folders'],
      'ECM Crawler Reports': ['reports-exec', 'reports-error', 'reports-history', 'reports-document', 'reports-queue'],
      'RDBMS Crawler Reports': ['reports-exec-rdbms', 'reports-error-rdbms', 'reports-history-rdbms'],
      'RDBMS Repository Configurations': ['rdbms-repo-general', 'rdbms-repo-connections', 'rdbms-repo-partitions'],
};
